import axios from '../../../../axios/index'
import store from '../../../../store/index.js'
import {Message} from "element-ui";

/**
 * 获取 供应商编辑里是否勾选了是否可获取到专线API对接渠道代码
 * @param logMsg
 * @returns {*}
 */
export function requestCanGetApiChannelCode(logMsg=false){
  let carrierId = store.state.Authorization.customerid;
  let url = `/pre/fba/getWhetherGetChannelCode?carrierId=${carrierId}`;
  let data = {

  };
  return axios.get(url, {params:data})
    .then(res=>{
      res = res.data ? res.data : {};
      if(res.code !== 1) return Promise.reject(new Error(res.message));
      return res;
    })
    .catch(res => {
      if(logMsg) Message.error("获取是否勾选专线API对接渠道代码标记：" + (res.message || "服务器繁忙"));
      return Promise.reject(res);
      // return Promise.resolve({
      //   code:0,
      //   message:`获取是否勾选专线API对接渠道代码标记：${res.message || "服务器繁忙"}`,
      // });
    });
}

/**
 * 获取 专线API对接渠道代码 列表
 * @param logMsg  {Boolean} 是否弹出错误提示
 * @returns {*}
 */
export function getApiChannelCodeList(logMsg=false){
  let carrierId = store.state.Authorization.customerid;
  let url = `/pre/fba/getChannelCode?carrierId=${carrierId}`;
  let data = {
  };
  return axios.get(url, {params:data,timeout:60 * 1000,})
    .then(res=>{
      res = res.data ? res.data : {};
      if(res.code !== 1) return Promise.reject(new Error(res.message));
      return res;
    })
    .catch(res => {
      if(logMsg) Message.error("获取专线API对接渠道代码列表：" + (res.message || "服务器繁忙"));
      return Promise.reject(res);
      // return Promise.resolve({
      //   code:0,
      //   message:`获取专线API对接渠道代码列表：${res.message || "服务器繁忙"}`,
      // });
    });
}



// WEBPACK FOOTER //
// ./src/components/QuotationManagement/components-productQuotation/selectApiChannelCode/utils.js